"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "../ui/button";
import { Share08Icon } from "@hugeicons/core-free-icons";
import { ShareModal } from "./ShareModal";
import { useState } from "react";

export interface ShareBtnProps {
  title: string;
  location: string;
  thumbnail: string;
}

export const ShareBtn: React.FC<ShareBtnProps> = ({
  title,
  location,
  thumbnail,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <Button
        variant="ghost"
        className="mr-auto font-normal hover:bg-[#F2F2F26E] h-11 !px-5"
        onClick={openModal}
      >
        <HugeiconsIcon icon={Share08Icon} className="size-6" />
        اشتراک گذاری
      </Button>
      <ShareModal
        isOpen={isOpen}
        onClose={closeModal}
        title={title}
        thumbnail={thumbnail}
        location={location}
      />
    </>
  );
};
